import useSWRMutation from 'swr/mutation';
import { ProductList } from '@/src/models/produk-kesehatan';
import { productService } from '../service';

interface IGetProductListParams {
  offset: number;
  size: number;
  search?: string | null;
  lat: number | undefined;
  long: number | undefined;
  min_price?: number | null;
  max_price?: number | null;
  lokasi?: string[] | null | undefined;
  order_by: string | undefined;
  is_not_ethical: boolean | undefined;
}

export function useGetProductList() {
  const fetchKey = ['product-list'];

  const { trigger, data, isMutating, error } = useSWRMutation(
    fetchKey,
    async (_, { arg }: { arg: IGetProductListParams }) => {
      return await productService.getMarketplaceProductList(arg);
    },
    {
      throwOnError: true,
    }
  );

  const execute = async (params: IGetProductListParams) => {
    return await trigger(params);
  };

  return {
    execute,
    data: data as ProductList | undefined,
    isLoading: isMutating,
    error,
  };
}
